module.exports = __webpack_public_path__ + "img/icon-certificates.1eb24f79.svg";